import { CardComponent } from "./card";

export const AppCard = CardComponent;
